export const CREATE_MODULE_REQUEST = "CREATE_QUARANTINE_REQUEST";
export const CREATE_MODULE_SUCCESS = "CREATE_QUARANTINE_SUCCESS";
export const CREATE_MODULE_FAILURE = "CREATE_QUARANTINE_FAILURE";

export const EDIT_MODULE_REQUEST = "EDIT_QUARANTINE_REQUEST";
export const EDIT_MODULE_SUCCESS = "EDIT_QUARANTINE_SUCCESS";
export const EDIT_MODULE_FAILURE = "EDIT_QUARANTINE_FAILURE";

export const CREATE_SUBMODULE_REQUEST = "CREATE_SUBMODULE_REQUEST";
export const CREATE_SUBMODULE_SUCCESS = "CREATE_SUBMODULE_SUCCESS";
export const CREATE_SUBMODULE_FAILURE = "CREATE_SUBMODULE_FAILURE";

export const EDIT_SUBMODULE_REQUEST = "EDIT_SUBMODULE_REQUEST";
export const EDIT_SUBMODULE_SUCCESS = "EDIT_SUBMODULE_SUCCESS";
export const EDIT_SUBMODULE_FAILURE = "EDIT_SUBMODULE_FAILURE";

export const CREATE_API_REQUEST = "CREATE_API_REQUEST";
export const CREATE_API_SUCCESS = "CREATE_API_SUCCESS";
export const CREATE_API_FAILURE = "CREATE_API_FAILURE";

export const CREATE_MAP_REQUEST = "CREATE_MAP_REQUEST";
export const CREATE_MAP_SUCCESS = "CREATE_MAP_SUCCESS";
export const CREATE_MAP_FAILURE = "CREATE_MAP_FAILURE";

export const CREATE_ACTIONS_REQUEST = "CREATE_ACTIONS_REQUEST";
export const CREATE_ACTIONS_SUCCESS = "CREATE_ACTIONS_SUCCESS";
export const CREATE_ACTIONS_FAILURE = "CREATE_ACTIONS_FAILURE";

export const EDIT_ACTIONS_REQUEST = "EDIT_ACTIONS_REQUEST";
export const EDIT_ACTIONS_SUCCESS = "EDIT_ACTIONS_SUCCESS";
export const EDIT_ACTIONS_FAILURE = "EDIT_ACTIONS_FAILURE";

export const GET_SUBMODULES_REQUEST = "GET_SUBMODULES_REQUEST";
export const GET_SUBMODULES_SUCCESS = "GET_SUBMODULES_SUCCESS";
export const GET_SUBMODULES_FAILURE = "GET_SUBMODULES_FAILURE";

export const GET_ACTION_BY_SUBMODULES_REQUEST = "GET_ACTION_BY_SUBMODULES_REQUEST";
export const GET_ACTION_BY_SUBMODULES_SUCCESS = "GET_ACTION_BY_SUBMODULES_SUCCESS";
export const GET_ACTION_BY_SUBMODULES_FAILURE = "GET_ACTION_BY_SUBMODULES_FAILURE";

export const GET_USERS_BY_CLIENTID_REQUEST = "GET_USERS_BY_CLIENTID_REQUEST";
export const GET_USERS_BY_CLIENTID_SUCCESS = "GET_USERS_BY_CLIENTID_SUCCESS";
export const GET_USERS_BY_CLIENTID_FAILURE = "GET_USERS_BY_CLIENTID_FAILURE";

export const GET_CLIENTS_REQUEST = "GET_CLIENTS_REQUEST";
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS";
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE";

export const GET_MODULES_REQUEST = "GET_MODULES_REQUEST";
export const GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS";
export const GET_MODULES_FAILURE = "GET_MODULES_FAILURE";

export const GET_COMPONENTS_REQUEST = "GET_COMPONENTS_REQUEST";
export const GET_COMPONENTS_SUCCESS = "GET_COMPONENTS_SUCCESS";
export const GET_COMPONENTS_FAILURE = "GET_COMPONENTS_FAILURE";

export const GET_ACTIONS_FOR_MAPPING_REQUEST = "GET_ACTIONS_FOR_MAPPING_REQUEST";
export const GET_ACTIONS_FOR_MAPPING_SUCCESS = "GET_ACTIONS_FOR_MAPPING_SUCCESS";
export const GET_ACTIONS_FOR_MAPPING_FAILURE = "GET_ACTIONS_FOR_MAPPING_FAILURE";

export const GET_API_REQUEST = "GET_API_REQUEST";
export const GET_API_SUCCESS = "GET_API_SUCCESS";
export const GET_API_FAILURE = "GET_API_FAILURE";

export const EDIT_API_REQUEST = "EDIT_API_REQUEST";
export const EDIT_API_SUCCESS = "EDIT_API_SUCCESS";
export const EDIT_API_FAILURE = "EDIT_API_FAILURE";

export const GET_MODULESBY_SUBMODULES_REQUEST = "GET_MODULESBY_SUBMODULES_REQUEST";
export const GET_MODULESBY_SUBMODULES_SUCCESS = "GET_MODULESBY_SUBMODULES_SUCCESS";
export const GET_MODULESBY_SUBMODULES_FAILURE = "GET_MODULESBY_SUBMODULES_FAILURE";

export const GET_ACTIONS_REQUEST = "GET_ACTIONS_REQUEST";
export const GET_ACTIONS_SUCCESS = "GET_ACTIONS_SUCCESS";
export const GET_ACTIONS_FAILURE = "GET_ACTIONS_FAILURE";
